import {
  RTM_ORDER_UPDATED,
  RTM_ORDER_MESSAGE,
  RTM_CONV_CREADTED,
  RTM_MANAGER_WORKING_STATE_CHANGED,
  RECEIVER_OFFLINE,
  RTM_NOTIFY_CENTER_MESSAGE,
  RTM_NOTIFY_USER_SUBSCRIBE,
  TASK_REFRESH,
  CONV_REFRESH,
  TODO_REFRESH,
  CHAOSHI_REFRESH,
  REPLY_REFRESH
} from './actionTypes'

export const convCreated = payload => ({ type: RTM_CONV_CREADTED, payload })
export const orderUpdated = payload => ({ type: RTM_ORDER_UPDATED, payload })
export const orderMessage = payload => ({ type: RTM_ORDER_MESSAGE, payload })
export const managerWorkingStateChanged = payload => ({ type: RTM_MANAGER_WORKING_STATE_CHANGED, payload })
export const receiverOffline = payload => ({ type: RECEIVER_OFFLINE, payload })
export const notifyCenterMessage = payload => ({ type: RTM_NOTIFY_CENTER_MESSAGE, payload })
export const userSubscribe = payload => ({ type: RTM_NOTIFY_USER_SUBSCRIBE, payload })
export const taskRefresh = payload => ({ type: TASK_REFRESH, payload })
export const convRefresh = payload => ({ type: CONV_REFRESH, payload })
export const todoRefresh = payload => ({ type: TODO_REFRESH, payload })
export const chaoshiRefresh = payload => ({ type: CHAOSHI_REFRESH, payload })
export const replyRefresh = payload => ({ type: REPLY_REFRESH, payload })
